import Vue from 'vue'
import App from './App'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI)

/* store */
import store from './store'
Vue.prototype.$store = store

/* 路由 */
import router from './router'

/* axios */
import axios from './api/request'
Vue.prototype.http = axios

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* 直播样式 */
import './assets/css/hxsh.live.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)



/* 直播官网组件 顶部 */
import LiveHeader from './components/live/LiveHeader'
Vue.component(LiveHeader.name,LiveHeader)

/* 直播官网组件 底部 */
import LiveFooter from './components/live/LiveFooter'
Vue.component(LiveFooter.name,LiveFooter)

// 全局 登录弹窗组件
import { LoginBox } from '@/components/loginCom'
Vue.prototype.$login = LoginBox;

// 全局 充值弹窗组件
import { ChongZhiBox } from '@/components/ChongZhiCom'
Vue.prototype.$chongZhi = ChongZhiBox;

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js